module.exports = __webpack_public_path__ + "static/img/pic_tophstj@2x.faa7febf.png";